<template>
  <div id="skills">
    <v-container>
      <v-row align="center" justify="center">
        <h3
          id="head"
          data-aos="fade-up"
          data-aos-duration="1000"
          style="margin-top:48px"
        >
          Skills
        </h3>
      </v-row>
      <v-row align="center" justify="space-around" class="mt-8 pt-4">
        <p
          class="skillslist d-flex justify-center"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <v-icon dark>mdi-graph</v-icon> Data Structures and Algorithms
        </p>
        <p class="skillslist" data-aos="fade-up" data-aos-duration="1000">
          <v-icon dark>mdi-android-studio</v-icon> Android Development
        </p>
        <p class="skillslist" data-aos="fade-up" data-aos-duration="1000">
          <v-icon dark>mdi-web</v-icon> Web Development
        </p>
      </v-row>
      <v-row align="center" justify="space-around" class="mt-8 pt-4">
        <p class="skillslist" data-aos="fade-up" data-aos-duration="1000">
          <v-icon dark>mdi-brain</v-icon> Machine Learning
        </p>
        <p class="skillslist" data-aos="fade-up" data-aos-duration="1000">
          <v-icon dark>mdi-state-machine</v-icon> Deep Learning
        </p>

        <p class="skillslist" data-aos="fade-up" data-aos-duration="1000">
          <v-icon dark>mdi-linux</v-icon> Linux
        </p>
      </v-row>
      <v-row align="center" justify="space-around" class="mt-8 pt-4 mx-16 px-6">
        <p class="skillslist" data-aos="fade-up" data-aos-duration="1000">
          <v-icon dark>mdi-language-javascript</v-icon> Javascript
        </p>
        <p class="skillslist" data-aos="fade-up" data-aos-duration="1000">
          <v-icon dark>mdi-language-python</v-icon> Python
        </p>
        <p class="skillslist" data-aos="fade-up" data-aos-duration="1000">
          <v-icon dark>mdi-language-c</v-icon> C
        </p>
        <p class="skillslist" data-aos="fade-up" data-aos-duration="1000">
          <v-icon dark>mdi-language-cpp</v-icon> C++
        </p>
        <p class="skillslist" data-aos="fade-up" data-aos-duration="1000">
          <v-icon dark>mdi-language-java</v-icon> Java
        </p>
      </v-row>
      <v-row align="center" justify="space-around" class="mt-8 pt-4 mx-10">
        <p class="skillslist" data-aos="fade-up" data-aos-duration="1000">
          <v-icon large>$flask</v-icon> Flask
        </p>
        <p class="skillslist" data-aos="fade-up" data-aos-duration="1000">
          <v-icon dark>mdi-database</v-icon> MySql
        </p>
        <p class="skillslist" data-aos="fade-up" data-aos-duration="1000">
          <v-icon dark></v-icon> Flutter
        </p>
        <p class="skillslist" data-aos="fade-up" data-aos-duration="1000">
          <v-icon dark>mdi-vuetify</v-icon> VueJs
        </p>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  name: "Skills"
};
</script>
<style scoped>
#skills {
  background-color: #252734;
  height: 600px;
}
#head {
  color: #999aa2;

  font-family: "Gilroy Regular";
  font-size: 2.5rem;
}
.skillslist {
  color: #e9e9eb;
  font-size: 1.5rem;
  font-family: "Gilroy SemiBold";
  /* padding-bottom: 20px; */
}
</style>
<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";
@media #{map-get(
    $display-breakpoints,
    "sm-and-down"
  )} {
  #skills {
    height: 1000px;
  }
}
@font-face {
  font-family: "Gilroy Bold";
  src: url("../assets/fonts/Gilroy-Bold.eot");
  src: url("../assets/fonts/Gilroy-Bold.eot?#iefix") format("embedded-opentype"),
    url("../assets/fonts/Gilroy-Bold.woff") format("woff"),
    url("../assets/fonts/Gilroy-Bold.otf") format("opentype"),
    url("../assets/fonts/Gilroy-Bold.ttf") format("truetype"),
    url("../assets/fonts/Gilroy-Bold.svg") format("svg");
}
@font-face {
  font-family: "Gilroy SemiBold";
  src: url("../assets/fonts/Gilroy-SemiBold.eot");
  src: url("../assets/fonts/Gilroy-SemiBold.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/Gilroy-SemiBold.woff") format("woff"),
    url("../assets/fonts/Gilroy-SemiBold.otf") format("opentype");
}
@font-face {
  font-family: "Gilroy Medium";
  src: url("../assets/fonts/Gilroy-Medium.eot");
  src: url("../assets/fonts/Gilroy-Medium.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/Gilroy-Medium.woff") format("woff"),
    url("../assets/fonts/Gilroy-Medium.otf") format("opentype");
}
@font-face {
  font-family: "Gilroy Regular";
  src: url("../assets/fonts/Gilroy-Regular.eot");
  src: url("../assets/fonts/Gilroy-Regular.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/Gilroy-Regular.woff") format("woff"),
    url("../assets/fonts/Gilroy-Regular.otf") format("opentype");
}
</style>
